import { Provider } from "@redotech/redo-order-common/provider";
import { Condition } from "@redotech/redo-return-core-common/return-flow/condition";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";

const NETSUITE_UNSUPPORTED_CONDITION_NAMES = [
  CONDITION_NAMES[Condition.COLLECTION],
  CONDITION_NAMES[Condition.ORDER_TIME_COLLECTION],
  CONDITION_NAMES[Condition.CUSTOMER_TAG],
  CONDITION_NAMES[Condition.ORDER_TAG],
  CONDITION_NAMES[Condition.PRODUCT_TAG],
  CONDITION_NAMES[Condition.PRODUCT_TYPE],
  CONDITION_NAMES[Condition.PRODUCT_VARIANT_METAFIELD],
  CONDITION_NAMES[Condition.PRODUCT_METAFIELD],
];

export function getUnsupportedReturnFlowConditionNames(
  provider: Provider | null | undefined,
): string[] {
  return provider === Provider.NETSUITE
    ? [...NETSUITE_UNSUPPORTED_CONDITION_NAMES]
    : [];
}
